module.exports = __webpack_public_path__ + "media/images/flags/VE-c92f6fe5e8e7e2a64c59b4182cfea67c.svg";